import * as React from "react";

import "./Radio.scss";

const Radio = (props) => {
  const { label, id, ...rest } = props;

  const inputId = id || `radio-${Math.floor(Math.random() * 1000)}`;

  return (
    <div className="form-check custom-radio form-check-inline">
      <input className="form-check-input" type="radio" id={inputId} {...rest} />
      <label className="form-check-label" htmlFor={inputId}>
        {label}
      </label>
    </div>
  );
};

export default Radio;
